'use client'

import React, { useEffect } from 'react'
import { Outlet } from 'react-router-dom'
import { useParams } from '@/lib/next-shim'
import LanguageProvider from '@/shared/ui/providers/LanguageProvider'
import { MetaTags } from '@/shared/ui/seo/MetaTags'

type RootLayoutProps = {
  children?: React.ReactNode
}

export default function RootLayout({ children }: RootLayoutProps) {
  const { lang } = useParams() as { lang: string }

  useEffect(() => {
    if (lang) {
      document.documentElement.lang = lang
    }
  }, [lang])

  return (
    <div className="h-full bg-gray-50">
      <MetaTags />
      <LanguageProvider lang={lang}>{children || <Outlet />}</LanguageProvider>
    </div>
  )
}
